import * as Yup from "yup";

export const RealReppDocsSchema = (isEdit = false) => Yup.object({
  name: Yup.string().required('Document Name is required!'),
  file: Yup.mixed()
    .required('Document File is required!')
    .test('', 'Only PDF file is allowed', (value) => {
      return value && (value as File)?.type === 'application/pdf';
    }),
});